import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchStreams, fetchStream, fetchGroup } from 'actions/streams';
import { fetchCollections, fetchCollection, fetchCollectionSection } from 'actions/collections';
import { searchAssets, invalidateAssetsSearch } from 'actions/assets';
import _ from 'lodash';
import cx from "classnames";
import dateformat from 'dateformat';

import {
  Row, Col, Image, Dropdown, Button, Tabs, Tab,
  InputGroup, FormControl, Accordion, Card, OverlayTrigger, Tooltip, Modal
} from "react-bootstrap";
import { useHistory, useLocation } from 'react-router-dom';

import InfiniteScroll from "react-infinite-scroller";
import Truncate from "react-truncate";
import DOMPurify from 'dompurify';

import FileService from 'services/file.service';

import styles from './contentLibrary.module.scss';
import defaultAsset from 'images/default_asset.jpg';
import GenerateLink from 'components/generateLink';
import LockIcon from 'components/lockIcon';
import SearchView from 'pages/search/searchView';
import { deselectAsset, selectAsset, selectCollection } from 'actions/selection';
import { trackAdoptionMetricsForAssetDetailViewedEvent, trackAdoptionMetricsForCollectionDetailViewedEvent, trackAdoptionMetricsForStreamDetailViewedEvent } from 'actions/adoption';

export default function ContentLibraryOld(props) {
  const dispatch = useDispatch();
  const history = useHistory();

  const webAppUrl = process.env.REACT_APP_WEBAPP_URL;

  const [asset, setAsset] = useState([]);
  const [showTabs, setShowTabs] = useState(true);

  const searching = useSelector((state) => _.get(state, 'assets.search.query') != '');
  const hubEnabled = useSelector((state) => _.get(state, 'users.account.item.hubEnabled'));
  const userRole = useSelector((state) => _.get(state, 'users.profile.item.userRoles[0]'));
  const assets = useSelector(state => _.get(state, `application.assets`, []));
  

  const handleSearchChanged = React.useCallback(
    _.debounce((query) => {

      if (query != "") {
        dispatch(searchAssets(query, 0, 20));
      } else {
        dispatch(invalidateAssetsSearch());
      }
    }, 500), []);

  useEffect(() => {
    dispatch(invalidateAssetsSearch());
  }, [])

  const handleShowTabs = (value) => {
    setShowTabs(value);
  }

  const handleBackClicked = () => {
    history.push("/paperflite-home")
  }

  const collectionsAccess = _.get(userRole, 'collection.access');
  const streamsAccess = _.get(userRole, 'hub.access');
  const searchAccess = _.get(userRole, 'search.access');

  return (
    <div className={cx(styles.contentLibrary, {
      [styles.hideMask]: _.size(assets) > 0 && props.attachAssets
    })}>
      <p className={styles.headerContainer}>
        <span className={styles.backButton} onClick={() => handleBackClicked()}>
          <i className="paperflite-left-arrow"/>
          <span className={styles.back}>
            streams & collections
          </span>
        </span>
        <span className={styles.subText}>
          Add assets from your streams & existing collections
        </span>
      </p>
      <Row>
        {!collectionsAccess && !streamsAccess && (
            <div className={styles.restrictedAccess}><span>You do not have access to streams & collections.</span></div>
          )}
        {(collectionsAccess || streamsAccess) && searchAccess &&
          <Col md={12} className={cx(styles.search)}>
            <SearchView handleShowTabs={handleShowTabs} webAppUrl={webAppUrl} attachAssets={props.attachAssets}/>
          </Col>}
        <Col md={12}>
          {showTabs && streamsAccess &&
            <Tabs className={styles.tabs}>
             
                <Tab eventKey="streams" title="Streams">
                {streamsAccess && hubEnabled &&
                  <MyStreams attachAssets = {props.attachAssets} webAppUrl={webAppUrl} attachedAssets={assets}/> 
                }
                {!streamsAccess && !hubEnabled &&
                  <span className={styles.emptyMessage}>You do not have access to streams</span>
                }
                </Tab>
             
             
                <Tab eventKey="collections" title="Collections">
                  {showTabs && collectionsAccess &&
                    <MyCollections attachAssets = {props.attachAssets} webAppUrl={webAppUrl} attachedAssets={assets}/>
                  }
                  {!collectionsAccess && 
                    <span className={styles.emptyMessage}>You do not have access to collections</span>
                  }
                </Tab>
             
            </Tabs>
          }
        </Col>
      </Row>
    </div>
  )
}

function SearchResult(props) {
  const dispatch = useDispatch();

  const query = useSelector((state) => _.get(state, 'assets.search.query'));
  const loading = useSelector((state) => _.get(state, 'assets.search.searching'));
  const assets = useSelector((state) => _.get(state, 'assets.search.items')) || [];
  const currentPage = useSelector((state) => _.get(state, 'assets.search.pagination.current'));
  const totalPages = useSelector((state) => _.get(state, 'assets.search.pagination.totalPages'));
  const [selectedAsset, setSelectedAsset] = useState();
  const [generateLink, setGenerateLink] = useState(false);

  const initialLoading = loading && assets.length === 0;

  const loadMoreItems = () => {
    if (loading) {
      return;
    }

    dispatch(searchAssets(query, currentPage + 1, 20));
  }

  const handleAssetClick = (asset) => {
    if (asset.settings && !asset.settings.share) {
      return;
    }
    setSelectedAsset(asset);
    setGenerateLink(true)
  }


  return (
    <div className={styles.searchResults}>
      {initialLoading &&
        <div className={cx(styles.loading, styles.initial)}>Searching assets...</div>
      }

      <InfiniteScroll
        pageStart={0}
        initialLoad={false}
        hasMore={currentPage < totalPages}
        loadMore={() => { loadMoreItems() }}
        useWindow={false}
        threshold={150}
      >
        {!loading && assets.length == 0 &&
          <div className={styles.empty}>No results found</div>
        }

        {selectedAsset && <GenerateLink entity={selectedAsset} type="asset" show={generateLink} setShow={setGenerateLink} />}

        {assets.map(asset => <AssetDetailNode handleAssetClick={handleAssetClick} key={asset.id} asset={asset} />)}

        {!initialLoading && loading &&
          <div className={styles.loading}>Loading more...</div>
        }
      </InfiniteScroll>
    </div>
  );
}

function MyCollections(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  
  const loading = useSelector((state) => _.get(state, 'collections.loading'));
  const collections = useSelector((state) => _.get(state, 'collections.items')) || [];
  const currentPage = useSelector((state) => _.get(state, 'collections.pagination.current'));
  const totalPages = useSelector((state) => _.get(state, 'collections.pagination.totalPages'));
  const error = useSelector((state) => _.get(state, 'collections.error'));

  const [selectedType, setSelectedType] = useState();
  const [content, setContent] = useState(null);
  const [generateLink, setGenerateLink] = useState(false);
  const [selectedAssets, setSelectedAssets] = useState([]);

  const initialLoading = loading && collections.length === 0;

  useEffect(() => {
    if(_.size(collections) === 0){
      dispatch(fetchCollections(0, 20));
    }
  }, [])

  useEffect(() => {
    setSelectedAssets(props.attachedAssets);
  }, [props.attachedAssets])

  const loadMoreItems = () => {
    if (loading || error) {
      return;
    }

    dispatch(fetchCollections(currentPage + 1, 20));
  }

  const handleSelectAsset = (selectedAsset) => {

    if(selectedAssets.includes(selectedAsset)){
      const filteredAssets = selectedAssets.filter(asset => asset.id != selectedAsset.id);
      setSelectedAssets(filteredAssets);
      dispatch(deselectAsset(selectedAsset));
    }else{
      setSelectedAssets([...selectedAssets, selectedAsset]);
      const allAssets = [...selectedAssets, selectedAsset];
      allAssets.map(asset => dispatch(selectAsset(asset)));
    }
  }

  const handleContentClick = (type, content) => {
    if(props.attachAssets){ 
      setContent(content);
      if(content.entityType === "collection"){
        dispatch(selectCollection(content));
        history.push("/attachAssets");
      }else{
        handleSelectAsset(content);
      }
    }else{
      setContent(content);
      setSelectedType(type);
      setGenerateLink(true);
    }
  }

  const handleAttachItems = () => {
    history.push("/attachAssets");
  }

  const isSelected = (selectedAsset) => {
    return props.attachedAssets.map(item => item.id).includes(selectedAsset.id);
}


  return (
    <div>
    <div className={cx(styles.collections, {
      [styles.adjustedHeight] : _.size(props.attachedAssets) > 0
    })}>
      {initialLoading &&
        <div className={cx(styles.loading, styles.initial)}>Loading collections...</div>
      }

      <InfiniteScroll
        pageStart={0}
        initialLoad={false}
        hasMore={currentPage < totalPages}
        loadMore={() => { loadMoreItems() }}
        useWindow={false}
        threshold={150}
      >
        {collections.filter(collection => {
          return collection.id != "uncategorized" && !collection.internal && !collection.dealRoom;
        }).map(collection => <CollectionNode handleContentClick={handleContentClick} key={collection.id} content={collection} isSelected={isSelected} webAppUrl={props.webAppUrl} attachAssets={props.attachAssets}/>)}

        {!initialLoading && loading &&
          <div className={styles.loading}>Loading more...</div>
        }

        {content && <GenerateLink entity={content} type={selectedType} show={generateLink} setShow={setGenerateLink} />}

      </InfiniteScroll>

      
    </div>
    {_.size(props.attachedAssets) > 0 &&
    <div className={styles.selectedItems} onClick={() => handleAttachItems()}>
          <span className={styles.selectedAssetsCount}>SELECTED ASSETS ({ _.size(props.attachedAssets)})</span>
    </div>
    }
    </div>
  );
}

export function MyStreams(props) {
  const dispatch = useDispatch();
  const history = useHistory();

  const loading = useSelector((state) => _.get(state, 'streams.loading'));
  const streams = useSelector((state) => _.get(state, 'streams.items')) || [];
  const [content, setContent] = useState();
  const [generateLink, setGenerateLink] = useState();
  const [selectedAssets, setSelectedAssets] = useState([]);

  useEffect(() => {
    if(_.size(streams) === 0){
      dispatch(fetchStreams());
    }
  }, []);

  useEffect(() => {
    setSelectedAssets(props.attachedAssets);
  }, [props.attachedAssets])

  const handleSelectAsset = (selectedAsset) => {

    if(selectedAssets.includes(selectedAsset)){
      const filteredAssets = selectedAssets.filter(asset => asset.id != selectedAsset.id);
      setSelectedAssets(filteredAssets);
      dispatch(deselectAsset(selectedAsset));
    }else{
      setSelectedAssets([...selectedAssets, selectedAsset]);
      const allAssets = [...selectedAssets, selectedAsset];
      allAssets.map(asset => dispatch(selectAsset(asset)));
    }
  }

  const handleContentClick = (type, content) => {
    if(props.attachAssets){
      setContent(content);
      handleSelectAsset(content);
    }else{
      setContent(content);
      setGenerateLink(true)
    }
  }

  const handleAttachItems = () => {
    history.push("/attachAssets");
  }

  const isSelected = (selectedAsset) => {
    return props.attachedAssets.map(item => item.id).includes(selectedAsset.id);
}

  return (
    <div>
    <div className={cx(styles.streams, {
      [styles.adjustedHeight] : _.size(props.attachedAssets) > 0
    })}>
      {loading &&
        <div className={cx(styles.loading, styles.initial)}>Loading streams...</div>
      }

      {content && <GenerateLink entity={content} type={"asset"} show={generateLink} setShow={setGenerateLink} />}

      {!loading && streams.map(stream => <StreamNode key={stream.id} handleContentClick={handleContentClick} stream={stream} isSelected={isSelected} webAppUrl={props.webAppUrl} attachAssets={props.attachAssets}/>)}

      </div>
      {_.size(props.attachedAssets) > 0 &&
      <div className={styles.selectedItems} onClick={() => handleAttachItems()}>
          <span className={styles.selectedAssetsCount}>SELECTED ASSETS ({ _.size(props.attachedAssets)})</span>
      </div>
      }
      </div>
  );
}

export function CollectionNode({ content, handleContentClick , isSelected, webAppUrl, attachAssets}) {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [activeSection, setActiveSection] = useState({
    index: 0,
    section: ''
  });
  const [sectionLoaded, setSectionLoaded] = useState(false);
  const [collectionSections, setCollectionSections] = useState([]);

  const loading = useSelector(state => _.get(state, `collections.collection.${content.id}.loading`) || _.get(state, `collections.collection.${content.id}.item.sections[${activeSection.index}].loading`)) || false;
  const collection = useSelector(state => _.get(state, `collections.collection.${content.id}.item`, null));
  const collectionAssets = useSelector(state => _.get(state, `collections.collection.${content.id}.item.assets`, []));
  const sectionAssets = useSelector(state => _.get(state, `collections.collection.${content.id}.item.sections[${activeSection.index}].assets`, []));

  var children = _.get(collection, 'sections') || _.get(collectionSections[0], 'assets') || [];;

  const handleClick = () => {
    if(!open){
      dispatch(trackAdoptionMetricsForCollectionDetailViewedEvent("Collection Detail Viewed", _.get(content, "name", "")));
    }
    setOpen(!open);
    if (!loaded) {
      dispatch(fetchCollection(content.id));
      setLoaded(true);
    }
  }

  const handleGenerateLink = (e) => {
    e.stopPropagation();
    handleContentClick("collection", content)
  }

  useEffect(() => {
    if (collectionSections.length > 0) {
      dispatch(fetchCollectionSection(content.id, collectionSections[0].id));
      setSectionLoaded(true);
    }
  }, [collectionSections]);

  useEffect(() => {
    if (collection != null && !sectionLoaded) {
      var sections = _.get(collection, 'sections') || [];
      setCollectionSections(sections);
      setActiveSection({
        index: 0,
        section: sections[0]
      });
    }
  }, [collection, sectionLoaded])

  if (_.size(children) === 0) {
    children = _.get(collection, 'assets') || [];
  }

  var assetsCount = collectionAssets.length > 0 ? collectionAssets.length : sectionAssets.length > 0 ? sectionAssets.length : 0;

  return (
    <Accordion className={cx(styles.accordion, styles.border, styles.collection)} key={content.id}>
      <Card className={styles.card}>
        <Accordion.Toggle as={Card.Header} eventKey={content.id} >
          <div className={cx(styles.row, styles.collection)} onClick={handleClick}>
            <div className={styles.collectionNameDetails}>
              <span className={cx(styles.name, {
                [styles.activeName]: open
              })}>{content.name}</span>
              <i className={cx(styles.icon, styles.expand, open ? "paperflite-up-arrow" : "paperflite-dropdown", {
                [styles.activeExpand]: open
              })} />
            </div> 
              <OverlayTrigger
              placement="top"
              overlay={<Tooltip className={styles.toolTip} id="tooltip-name">Generate Link</Tooltip>}
              >
              <i className={cx("paperflite-link", styles.attachCollectionIcon)} onClick={handleGenerateLink} />
              </OverlayTrigger>
            
            <a href={`${webAppUrl}/collections/${content.id}?source=chrome_extension`} target = "_blank">
            <OverlayTrigger
            placement="top"
            overlay={<Tooltip className={styles.toolTip} id="tooltip-name">Preview</Tooltip>}
            >
            <i className={cx("paperflite-left-arrow", styles.linkIcon)} 
            onClick={(e) => {
            e.stopPropagation()
            dispatch(trackAdoptionMetricsForCollectionDetailViewedEvent("Collection Detail Viewed", _.get(content, "name", "")));
            }}>
            </i>
            </OverlayTrigger>
            </a>

          </div>
        </Accordion.Toggle>

        <Accordion.Collapse eventKey={content.id}>
          <Card.Body>
            {(!loading || sectionLoaded) &&
              <p className={styles.assetsCount}>
                {assetsCount > 0 && (assetsCount > 1 ? `${assetsCount} assets` : "1 asset")}
              </p>
            }
            {collectionSections.length > 0 &&
              <Dropdown className={styles.collectionSections}>
                <Dropdown.Toggle>
                  <div className={styles.selectedSection}>
                    {activeSection.section.name}
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu className={styles.sectionItems}>
                  {collectionSections.map((section, index) => {
                    return (
                      <Dropdown.Item eventKey={content.id} className={styles.sectionName} key={section.id} onSelect={() => {
                        dispatch(fetchCollectionSection(content.id, section.id));
                        setActiveSection({
                          index: index,
                          section: section
                        });
                      }}>
                        {section.name}
                      </Dropdown.Item>
                    )
                  })}
                </Dropdown.Menu>
              </Dropdown>
            }
            <div className={styles.entityChildren}>
              {loading && collectionAssets.length === 0 &&
              <div className={styles.loadingWrapper}>
                <div className={cx(styles.loading, styles.initial)}>Loading assets...</div>
              </div>
              }
              {!loading && (collectionAssets.length === 0 && sectionAssets.length === 0) &&
              <div className={styles.loadingWrapper}>
                <div className={cx(styles.loading, styles.initial)}>No assets</div>
              </div>
              }
              {collectionAssets.length > 0 &&
                collectionAssets.map(item => {
                  return <AssetNode key={item.id} asset={item} handleContentClick={handleContentClick} isSelected={isSelected} webAppUrl={webAppUrl} attachAssets={attachAssets}/>
                })}
              {sectionAssets.length > 0 &&
                sectionAssets.map(item => {
                  return <AssetNode key={item.id} asset={item} handleContentClick={handleContentClick} isSelected={isSelected} webAppUrl={webAppUrl} attachAssets={attachAssets}/>
                })}
            </div>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
}

function AssetNode({ asset, handleContentClick, isSelected, webAppUrl, attachAssets }) {
  const dispatch = useDispatch();

  const handleGenerateLink = (asset) => {
    if (asset.settings && !asset.settings.share) {
      return;
    }
    handleContentClick("asset", asset)
  }

  return (
    <div className={cx(styles.asset, {
    })} key={asset.id} >
      <span className={cx(styles.assetIcon, {
      })
      }
      onClick={() => handleGenerateLink(asset)}
      >
        {asset.settings && !asset.settings.share && <span className={styles.lockIcon}><LockIcon /></span>}
        <img
          alt="asset thumbnail"
          src={_.get(asset, "icon.thumbnail") || defaultAsset} 
          className={cx({
             [styles.selectedAsset] : attachAssets && isSelected &&  isSelected(asset)
          })}
          />
        {!_.isEmpty(FileService.fileType(asset.metadata)) &&
          <p className={styles.fileType}>{FileService.fileType(asset.metadata)}</p>
        }

      </span>
      
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip className={styles.toolTip} id="tooltip-name">{asset.name}</Tooltip>}
      >
        <div className={styles.assetDetails}>
        <div className={cx(styles.name)}>
          {asset.name}
        </div>
        <span><a href={`${webAppUrl}/assets/${asset.id}?source=chrome_extension`} 
          target = "_blank" onClick={(e) => {
            e.stopPropagation()
            dispatch(trackAdoptionMetricsForAssetDetailViewedEvent("Asset Detail Viewed", "Content Library", FileService.fileType(_.get(asset, "metadata"))))
            }}>
          <i className={cx('paperflite-left-arrow', styles.previewIcon)}> </i>
          </a>
        </span>
        </div>
      </OverlayTrigger>
    </div>
  );
}

export function StreamNode({ stream, handleContentClick, isSelected, webAppUrl, attachAssets}) {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const handleClick = () => {
    if(!open){
      dispatch(trackAdoptionMetricsForStreamDetailViewedEvent("Stream Detail Viewed", _.get(stream, "name", "")));
    }
    setOpen(!open);
    if (!loaded) {
      dispatch(fetchStream(stream.id));
      setLoaded(true);
    }
  }

  const children = useSelector(state => _.get(state, `streams.stream.${stream.id}.item.children`, []));
  const loading = useSelector(state => _.get(state, `streams.stream.${stream.id}.loading`, false)) && children.length == 0;

  return (
    <Accordion
      className={cx(styles.accordion, styles.border)}
      key={stream.id}
    >
      <Card className={styles.card}>
        <Accordion.Toggle as={Card.Header} eventKey={stream.id} onClick={handleClick}>
          <div className={cx(styles.row, styles.stream)}>
            <div className={styles.streamNameDetails}>
              <span className={cx(styles.name, {
                [styles.activeName]: open
              })} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(stream.name)}}></span>
              <i className={cx(styles.icon, styles.expand, open ? "paperflite-up-arrow" : "paperflite-dropdown", {
                 [styles.activeExpand]: open
              })} />

              <a href={`${webAppUrl}/streams/${stream.id}?source=chrome_extension`} target = "_blank" className={styles.linkIconWrapper}>
              <OverlayTrigger
              placement="top"
              overlay={<Tooltip className={styles.toolTip} id="tooltip-name">Preview</Tooltip>}
              >
              <i className={cx("paperflite-left-arrow", styles.linkIcon)} 
              onClick={(e) => {
                e.stopPropagation()
                dispatch(trackAdoptionMetricsForStreamDetailViewedEvent("Stream Detail Viewed", _.get(stream, "name", "")));
                }}>
              </i>
              </OverlayTrigger>
              </a>

          </div>
          </div>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={stream.id}>
          <Card.Body>
            <div className={styles.entityChildren}>

              {loading && _.size(children) === 0 &&
              <div className={styles.loadingWrapper}>
                <div className={cx(styles.loading, styles.initial)}>Loading...</div>
              </div>
              }

              {!loading && _.size(children) === 0 &&
              <div className={styles.loadingWrapper}>
                <div className={cx(styles.loading, styles.initial)}>No assets</div>
              </div>
              }

              {children.filter(item => item.entityType === 'group').map(item => {
                return <GroupNode key={item.id} group={item} source={stream.id}/>
              })}

              {children.filter(item => item.entityType === 'asset').map(item => {
                return <AssetNode handleContentClick={handleContentClick} key={item.id} asset={item} isSelected={isSelected} webAppUrl={webAppUrl} attachAssets={attachAssets}/>
              })}
            </div>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
}

function GroupNode({ group, source }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const handleClick = () => {
    setOpen(!open);
    if (!loaded) {
      dispatch(fetchGroup(group.id));
      setLoaded(true);
    }
  }

  const handleRedirect = () => {
    const newUrl = `${location.pathname}/group/${group.id}?source=streams/${source}`;
    history.push(newUrl)
  }

  return (
    <div className={styles.group} onClick={handleRedirect}>
      <span className={styles.groupIcon}>
        <div className={styles.layer}>&nbsp;</div>
        <div className={styles.groupThumbnail}>
          <img
            alt="group thumbnail"
            src={_.get(group, "icon.thumbnail") || defaultAsset} />
        </div>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip className={styles.toolTip} id="tooltip-name">{group.name}</Tooltip>}
        >
          <div className={styles.name}>
            {group.name}
          </div>
        </OverlayTrigger>
      </span>
    </div>
  );
}

function AssetDetailNode({ asset, handleAssetClick }) {
  const dispatch = useDispatch();

  const icon = _.get(asset, 'icon.thumbnail') || "/images/default_asset.jpg"
  var assetSummary = renderAssetSummary(asset);

  return (
    <div key={asset.id} onClick={() => handleAssetClick(asset)} className={styles.searchAsset}>
      <span className={styles.assetIcon}>
        {asset.settings && !asset.settings.share && <LockIcon />}
        <img
          alt="asset thumbnail"
          src={_.get(asset, "icon.thumbnail") || defaultAsset} />
        <p className={styles.fileType}>{FileService.fileType(asset.metadata)}</p>
      </span>
      <div className={styles.searchAssetText}>
        <p className={styles.searchAssetHeading}>{asset.name}</p>
        <p className={styles.searchAssetSubHeading}>
          {assetSummary &&
            <span className={styles.assetSummary}>{assetSummary}</span>
          }
          <span>{FileService.formatSize(asset.metadata.content_length)}</span>
        </p>
        {asset.modifiedDate != null &&
          <p className={styles.searchAssetSubText}>Last update {dateformat(asset.modifiedDate, 'dd mmm yyyy')}</p>
        }
      </div>
    </div>
  );
}

const renderAssetSummary = (asset) => {
  if (asset.metadata.pages) {
    return (
      <div className={styles.metrics}>
        <span>{asset.metadata.pages} Pages</span>
      </div>
    );
  } else if (asset.metadata.video_duration) {
    return (
      <div className={styles.metrics}>
        <span>{formartVideoDuration(asset.metadata.video_duration)}</span>
      </div>
    );
  }

  return false;
}

const formartVideoDuration = (timeSpent) => {
  let timeSpentValue = `${padNumber(timeSpent, 1)} Seconds`;

  if (timeSpent >= 60) {
    var minutes = Math.round(timeSpent / 60);
    timeSpentValue = `${padNumber(minutes, 1)} Minute${minutes == 1 ? '' : 's'}`;
  }

  return timeSpentValue;
}

const padNumber = (number = 0, pad) => {
  number = Math.ceil(number);

  const length = pad - String(number).length + 1;
  let padding = '';
  if (length > 0) {
    padding = Array(pad - String(number).length + 1).join('0');
  }
  return padding + number;
}